import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import moment from 'moment-timezone';
import React, { ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import config from '@/config';
import { growthbook } from '@/core/growthbook';
import { OpenAPI } from '@/openapi';

OpenAPI.BASE = config.harnessApiUrl;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

/*

  Examples of how to use GrowthBook:

  - Feature hooks: https://www.npmjs.com/package/@growthbook/growthbook-react#feature-hooks
  - Feature wrapper components: https://www.npmjs.com/package/@growthbook/growthbook-react#feature-wrapper-components

*/

interface AppProps {
  children?: ReactNode;
}

const App = ({ children }: AppProps) => {
  // Features are loaded in main(), before the router is built: route loaders
  // read the EPA kill switch and run ahead of the first render (ENG-5601).

  // KT: Harness providers are commented out for now.

  return (
    <GrowthBookProvider growthbook={growthbook}>
      {/* <LocationListener> */}
      <GoogleReCaptchaProvider reCaptchaKey={config.recaptchaSiteKey || ''}>
        <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools />
            {React.Children.only(children)}
            {/* <KnowledgeSummaryDialog /> */}
          </QueryClientProvider>
        </LocalizationProvider>
      </GoogleReCaptchaProvider>
      {/* </LocationListener> */}
    </GrowthBookProvider>
  );
};

export default App;
